import React from 'react'
import Frame from './Iframe'
export default function index() {
  return (
    <Frame/>
  )
}
